var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCartReduce = function SvgIconCartReduce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22292F",
    d: "M11.333 7.833H4.667a.667.667 0 1 0 0 1.333h6.666a.667.667 0 1 0 0-1.333"
  })));
};
export { SvgIconCartReduce as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMzMzMgNy44MzMwMUg0LjY2NjY3QzQuMjk4NDggNy44MzMwMSA0IDguMTMxNDggNCA4LjQ5OTY3QzQgOC44Njc4NiA0LjI5ODQ4IDkuMTY2MzQgNC42NjY2NyA5LjE2NjM0SDExLjMzMzNDMTEuNzAxNSA5LjE2NjM0IDEyIDguODY3ODYgMTIgOC40OTk2N0MxMiA4LjEzMTQ4IDExLjcwMTUgNy44MzMwMSAxMS4zMzMzIDcuODMzMDFaIiBmaWxsPSIjMjIyOTJGIi8+Cjwvc3ZnPgo=";